<script setup lang="ts">
import {
  formProductKeys,
  productForms,
} from "~/components/Hubspot/productForms"

definePageMeta({
  name: "registerInterest",
  title: "Registrer interesse",
})

const products = useProductVariantsStore()

const activeProductKey = computed(() =>
  formProductKeys.find(
    it => it === products.activeProduct?.productKey,
  ),
)
</script>

<template>
  <UHubspotForm
    v-if="activeProductKey"
    :form-url="productForms[activeProductKey].url"
    :sub-title="productForms[activeProductKey].subTitle"
    title="Hold deg oppdatert på lanseringen!"
  />
  <section v-else class="mt-20 flex flex-col gap-10 sm:items-center">
    <p class="font-national2">
      Vi har dessverre ikke lagt ut interesseskjemaet for dette
      produktet, prøv igjen senere!
    </p>
    <UButton
      variant="filled"
      theme="cta"
      pill
      :href="`/produkter/${products.activeProduct?.urlFormatProductTitle}`"
    >
      Gå til produktet
    </UButton>
  </section>
</template>
